import { createRequest } from '../../services/request';

export enum SELLER_ACTION_TYPE {
  GET_SELLER = 'SELLER/GET_SELLER',
}

export const GET_SELLER = createRequest(SELLER_ACTION_TYPE.GET_SELLER);
